import { AxiosInstance } from 'axios';
import { User } from 'referral-types';
import { addFormValues, simulate } from './utils';
import { Size } from '../constants';
import { type FormFields } from '../components/user/user.schema';
import { SITE_URL } from './service';

export const baseEndpoint = 'user';

export class UserApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getUser(id: string): Promise<User> {
    await simulate();
    const response = await this.apiInstance.get(`/${id}`);

    return response.data;
  }

  getUserImageSrc(imageId: string, size?: Size): string {
    return `${SITE_URL}/image/user/${imageId}?size=${size || Size.sm}`;
  }

  async searchUsers(searchDirectory: UserSearchDirectory): Promise<Array<User>> {
    await simulate();
    const response = await this.apiInstance.post(`/search`, searchDirectory);

    return response.data;
  }

  async updateUser(userId: string, formValues: Partial<FormFields>): Promise<User> {
    await simulate();
    const formData = new FormData();

    addFormValues(formValues, formData);
    
    const response = await this.apiInstance.put(
      `/${userId}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    return response.data;
  }

  async searchUsersByReferralId(referralId: string, searchDirectory: UserSearchDirectory): Promise<Array<User>> {
    await simulate();
    const response = await this.apiInstance.post(`/search/referral/${referralId}`, searchDirectory);

    return response.data;
  }
}

type UserSearchDirectory = {
  filter?: string;
  isSponsorsOnly?: boolean;
};
